/* eslint-disable no-nested-ternary */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { Field, reduxForm, reset, change, getFormValues } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import _ from 'lodash';
import AddSharpIcon from '@material-ui/icons/AddSharp';

import { Grid } from '@material-ui/core';
import styles from './styles';
import Button from '../../../Button';
import {
  FORMS,
  VIEWABLE_FORM_MODES,
  USER_PROFILE_TYPES,
  IMAGE_SIZE_LIMIT,
  FILE_TYPE_ERROR,
  IMAGE_SIZE_LIMIT_MESSAGE,
} from '../../../../constants';
import {
  selectIsUpdatingBusinessProfile,
  selectBusinessProfileFormMode,
  selectSkillsetBuildOptions,
  selectSkillsetLookOptions,
  selectBuilderProjectGallery,
} from '../../../../store/selectors';
import {
  editUserProfile,
  editUserProfileCancelled,
  updateBusinessAttributes,
} from '../../../../store/actions/userProfile';
import { getSkillsetOfType } from '../../../../store/actions/skillset';
import TextField from '../../../../fields/reduxForm/ViewableTextField';
import { required } from '../../../../utilities/validators';
import PlaceSearchFormField from '../../../../fields/reduxForm/ViewablePlaceSearchFormField';
import JsonPlaceSearchFormField from '../../../../fields/reduxForm/ViewableJsonPlaceSearchFormField';
import ButtonSelectFormField from '../../../../fields/reduxForm/ViewableButtonSelectFormField';
import ImageUploadField from '../../../../fields/reduxForm/ImageUploadField';

import {
  setBuilderProjectGalleryImages,
  removeImageBuilderProjectGalleryImages,
  resetBuilderProjectGalleryImages,
} from '../../../../store/actions/builderPics';
import { apiCallFailed } from '../../../../store/actions/notification';

export const imageHandler = (file, action) => {
  const reader = new FileReader();
  reader.onloadend = () => {
    action(reader.result, file);
  };
  reader.readAsDataURL(file[0]);
};

const propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  classes: PropTypes.shape({
    actionsRow: PropTypes.string,
  }).isRequired,
  initialValues: PropTypes.object.isRequired,
  isUpdatingBusinessProfile: PropTypes.bool.isRequired,
  businessProfileFormMode: PropTypes.oneOf([
    VIEWABLE_FORM_MODES.EDITING,
    VIEWABLE_FORM_MODES.VIEWING,
  ]).isRequired,
  onEditUserProfile: PropTypes.func.isRequired,
  onEditUserProfileCancelled: PropTypes.func.isRequired,
  onResetForm: PropTypes.func.isRequired,
  onUpdateBusinessAttributes: PropTypes.func.isRequired,
  enableEditing: PropTypes.bool.isRequired,
  skillsetBuildOptions: PropTypes.array.isRequired,
  skillsetLookOptions: PropTypes.array.isRequired,
  onGetSkillsetOfType: PropTypes.func.isRequired,
};

export const BuilderProfileBusinessForm = props => {
  const {
    classes,
    isUpdatingBusinessProfile,
    businessProfileFormMode,
    onEditUserProfile,
    onEditUserProfileCancelled,
    onResetForm,
    handleSubmit,
    initialValues,
    onUpdateBusinessAttributes,
    enableEditing,
    skillsetBuildOptions,
    skillsetLookOptions,
    onGetSkillsetOfType,
    formValues,
    builderProjectGallery,
    setProjectGalleryImages,
    removeImageFromBuilderProjectGalleryImages,
    changeFieldValue,
    resetProjectGalleryImages,
    onAddNotification,
  } = props;

  // console.log('initialValues', initialValues);
  useEffect(() => {
    if (!skillsetBuildOptions.length) onGetSkillsetOfType('build');
    if (!skillsetLookOptions.length) onGetSkillsetOfType('look');
    // console.log(skillsetBuildOptions.length);
    return () => {
      onResetForm(FORMS.BUILDER_PROFILE_BUSINESS);
      onEditUserProfileCancelled(USER_PROFILE_TYPES.BUSINESS);
    };
  }, []);

  useEffect(() => {
    if (formValues) {
      // console.log('formValues', formValues);

      if (formValues.logo && formValues.logo !== 'removed') {
        if (!formValues.logo[0].type.includes('image/')) {
          onAddNotification(FILE_TYPE_ERROR);
          return;
        }
        if (formValues.logo[0].size > IMAGE_SIZE_LIMIT) {
          onAddNotification(IMAGE_SIZE_LIMIT_MESSAGE);
          builderPhotoInputRef.current.value = null;
        } else {
          imageHandler(formValues.logo, setPreviewBuilderPhoto);
        }
      }
      if (formValues.coverPhoto && formValues.coverPhoto !== 'removed') {
        if (!formValues.coverPhoto[0].type.includes('image/')) {
          onAddNotification(FILE_TYPE_ERROR);
          return;
        }
        if (formValues.coverPhoto[0].size > IMAGE_SIZE_LIMIT) {
          onAddNotification(IMAGE_SIZE_LIMIT_MESSAGE);
          builderBannerInputRef.current.value = null;
        } else imageHandler(formValues.coverPhoto, setPreviewBuilderBanner);
      }
    }
  }, [formValues]);

  const builderPhotoInputRef = useRef();
  const builderBannerInputRef = useRef();
  const projectGalleryInputRef = useRef();

  const [previewBuilderPhoto, setPreviewBuilderPhoto] = useState(
    _.get(initialValues, 'logoImage.file'),
  );
  const [previewBuilderBanner, setPreviewBuilderBanner] = useState(
    _.get(initialValues, 'coverPhotoImage.file'),
  );

  useEffect(() => {
    // console.log('Useeffect', _.get(initialValues, 'logoImage'));
    // console.log('isUpdatingBusinessProfile', isUpdatingBusinessProfile);

    if (!isUpdatingBusinessProfile) {
      setPreviewBuilderPhoto(_.get(formValues, 'logoImage.file'));
      setPreviewBuilderBanner(_.get(formValues, 'coverPhotoImage.file'));
      resetProjectGalleryImages();
      _.forEach(_.get(formValues, 'galleryImages'), item => {
        // removeImageFromBuilderProjectGalleryImages(index);
        if (item)
          setProjectGalleryImages({
            image: item.file,
            id: item.id,
            status: item.status,
          });
      });
    }
  }, [formValues]);

  const projectGalleryImagesHandler = files => {
    if (files && files.length) {
      // console.log(files);
      const invalidIndexes = [];
      let hasInvalidFileSize = false;
      let hasInvalidFileType = false;
      _.forEach(files, (file, index) => {
        if (file.size > IMAGE_SIZE_LIMIT) {
          invalidIndexes.push(index);
          hasInvalidFileSize = true;
        }
        if (!file.type.includes('image/')) {
          invalidIndexes.push(index);
          hasInvalidFileType = true;
        }
      });
      let filteredFiles = files;
      if (invalidIndexes.length > 0) {
        filteredFiles = [...files].filter(
          (item, index) => !invalidIndexes.includes(index),
        );
      }

      // console.log('Filtered', filteredFiles);
      if (hasInvalidFileType) {
        onAddNotification(FILE_TYPE_ERROR);
      } else if (hasInvalidFileSize) {
        onAddNotification(IMAGE_SIZE_LIMIT_MESSAGE);
      }
      _.forEach(filteredFiles, file => {
        imageHandler([file], projectGalleryImagesCollector);
      });
    }
  };
  const projectGalleryImagesCollector = (image, file) => {
    setProjectGalleryImages({ file, image });
  };

  const handleFormSubmitted = values => {
    values.galleryImages = builderProjectGallery;
    // console.log(`Updated value: `, values);
    if (initialValues.galleryImages[0] === null) {
      initialValues.galleryImages = [];
    }
    // console.log({ values, initialValues });
    // return;
    onUpdateBusinessAttributes(
      localStorage.getItem('accessToken'),
      USER_PROFILE_TYPES.BUSINESS,
      values,
      initialValues,
    );
  };

  const renderFormButton = () => {
    // console.log('businessProfileFormMode', businessProfileFormMode);
    // console.log('enableEditing', enableEditing);
    if (businessProfileFormMode === VIEWABLE_FORM_MODES.VIEWING) {
      return (
        <div className={classes.editButton}>
          <Button
            type="button"
            variant="outlined"
            color="primary"
            fullWidth
            onClick={handleClick}
            disabled={!enableEditing}
          >
            Edit
          </Button>
        </div>
      );
    }

    return (
      <div className={classes.formButtons}>
        <Button
          type="button"
          variant="outlined"
          color="primary"
          onClick={handleFormCancel}
          disabled={!enableEditing || isUpdatingBusinessProfile}
        >
          Cancel
        </Button>
        <Button
          type="button"
          variant="contained"
          color="primary"
          onClick={handleSubmit(handleFormSubmitted)}
          disabled={!enableEditing || isUpdatingBusinessProfile}
        >
          {isUpdatingBusinessProfile && <CircularProgress size={20} />}
          {!isUpdatingBusinessProfile && 'Done'}
        </Button>
      </div>
    );
  };

  const handleFormCancel = e => {
    e.preventDefault();
    onResetForm(FORMS.BUILDER_PROFILE_BUSINESS);
    onEditUserProfileCancelled(USER_PROFILE_TYPES.BUSINESS);
  };

  const handleClick = () => {
    onEditUserProfile(USER_PROFILE_TYPES.BUSINESS);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className={classes.topImageFormGroup}>
        {/* <div
            // className={classNames(classes.formGroup, classes.halfFormGroup)}
            > */}
        <div className={classes.topImageSingle}>
          {previewBuilderPhoto ? (
            <div className={classes.imageOuterContainer}>
              <div className={classes.imageContainer}>
                <img
                  src={previewBuilderPhoto}
                  alt="builder profile"
                  className={classes.profilePhoto}
                />
                {_.get(formValues, 'logoImage.status', 0) === 0 && (
                  <div className={classes.caption}>Pending approval</div>
                )}
                {businessProfileFormMode === VIEWABLE_FORM_MODES.EDITING && (
                  <Grid
                    className={classes.remove}
                    onClick={() => {
                      setPreviewBuilderPhoto(null);
                      // setBuilderPhoto(null);
                      builderPhotoInputRef.current.value = null;
                      changeFieldValue('logo', 'removed');
                      changeFieldValue('logoImage', 'removed');
                    }}
                  >
                    x
                  </Grid>
                )}
              </div>
            </div>
          ) : (
            <Grid className={classes.photoUpload}>
              {businessProfileFormMode === VIEWABLE_FORM_MODES.EDITING ? (
                <Grid
                  onClick={() => builderPhotoInputRef.current.click()}
                  className={classes.anchor}
                >
                  <AddSharpIcon />
                  Add Image
                </Grid>
              ) : (
                'No Image'
              )}
            </Grid>
          )}

          <p className={classes.textLabel}> Profile Image</p>

          <Field
            component={ImageUploadField}
            name="logo"
            props={{
              id: 'builder-profile',
            }}
            reference={builderPhotoInputRef}
          />
        </div>
        <div className={classes.topImageSingle}>
          {previewBuilderBanner ? (
            <div>
              <div className={classes.imageContainer}>
                <>
                  <img
                    src={previewBuilderBanner}
                    alt="builder profile"
                    className={classes.profilePhoto}
                  />
                  {_.get(formValues, 'coverPhotoImage.status', 0) === 0 && (
                    <div className={classes.caption}>Pending approval</div>
                  )}
                </>
                {businessProfileFormMode === VIEWABLE_FORM_MODES.EDITING && (
                  <Grid
                    className={classes.remove}
                    onClick={() => {
                      // setBuilderBanner(null);
                      setPreviewBuilderBanner(null);
                      builderBannerInputRef.current.value = null;
                      changeFieldValue('coverPhoto', 'removed');
                      changeFieldValue('coverPhotoImage', 'removed');
                    }}
                  >
                    x
                  </Grid>
                )}
              </div>
            </div>
          ) : (
            <Grid className={classes.photoUpload}>
              {businessProfileFormMode === VIEWABLE_FORM_MODES.EDITING ? (
                <Grid
                  onClick={() => builderBannerInputRef.current.click()}
                  className={classes.anchor}
                >
                  <AddSharpIcon />
                  Add Image
                </Grid>
              ) : (
                'No Image'
              )}
            </Grid>
          )}
          <p className={classes.textLabel}>Cover Photo</p>

          <Field
            component={ImageUploadField}
            name="coverPhoto"
            props={{
              ref: builderBannerInputRef,
              id: 'builder-banner',
            }}
            reference={builderBannerInputRef}
          />
        </div>
      </div>
      <div className={classes.formRow}>
        <div className={classNames(classes.formGroup, classes.halfFormGroup)}>
          <Field
            name="businessName"
            component={TextField}
            props={{
              id: 'business-name-text-field',
              label: 'Business Name',
              fullWidth: true,
            }}
            initialValue={initialValues.businessName}
            isEditing={businessProfileFormMode === VIEWABLE_FORM_MODES.EDITING}
            validate={[required]}
          />
        </div>
        <div className={classNames(classes.formGroup, classes.halfFormGroup)}>
          <Field
            name="businessPosition"
            component={TextField}
            props={{
              id: 'position-text-field',
              label: 'Position',
              fullWidth: true,
            }}
            initialValue={initialValues.businessPosition}
            isEditing={businessProfileFormMode === VIEWABLE_FORM_MODES.EDITING}
            validate={[required]}
          />
        </div>
      </div>
      <div className={classes.formRow}>
        <div className={classes.formGroup}>
          <Field
            name="businessDescription"
            component={TextField}
            props={{
              id: 'profile-description-text-field',
              label: 'Profile Description',
              fullWidth: true,
              inputProps: {
                maxLength: 240,
              },
            }}
            initialValue={initialValues.businessDescription}
            isEditing={businessProfileFormMode === VIEWABLE_FORM_MODES.EDITING}
            multiline
            rows={2}
            validate={[required]}
          />
        </div>
      </div>
      <div className={classes.formRow}>
        <div className={classes.formGroup}>
          <div className={classes.galleryContainer}>
            <p className={classes.textLabel}>Project Gallery</p>
            <div className={classes.galleryImages}>
              {businessProfileFormMode === VIEWABLE_FORM_MODES.EDITING ? (
                <Grid
                  className={classes.photoUpload}
                  onClick={() => projectGalleryInputRef.current.click()}
                >
                  <AddSharpIcon />
                  Add Images
                </Grid>
              ) : builderProjectGallery.length === 0 ? (
                <Grid className={classes.photoUpload}>No Images</Grid>
              ) : (
                ''
              )}
              {/* <Grid className={classes.photoUpload}>
                {businessProfileFormMode === VIEWABLE_FORM_MODES.EDITING ? (
                  <Grid
                    onClick={() => projectGalleryInputRef.current.click()}
                    className={classes.anchor}
                  >
                    <AddSharpIcon />
                    Add Image
                  </Grid>
                ) : (
                  'No Images'
                )}
              </Grid> */}

              {builderProjectGallery.length > 0 &&
                builderProjectGallery.map((image, index) => (
                  <div className={classes.imageContainer}>
                    <img
                      src={image.image}
                      alt="project-gallery"
                      className={classes.profilePhoto}
                    />
                    {_.get(image, 'status', 0) === 0 && (
                      <div className={classes.caption}>Pending approval</div>
                    )}
                    {businessProfileFormMode ===
                      VIEWABLE_FORM_MODES.EDITING && (
                      <Grid
                        className={classes.remove}
                        onClick={() => {
                          const arr = builderProjectGallery;
                          arr.splice(index, 1);
                          removeImageFromBuilderProjectGalleryImages(index);
                        }}
                      >
                        x
                      </Grid>
                    )}
                  </div>
                ))}
            </div>
            <input
              ref={projectGalleryInputRef}
              type="file"
              accept="image/*"
              multiple="multiple"
              id="project-gallery"
              name="gallery"
              style={{ display: 'none' }}
              onChange={e => projectGalleryImagesHandler(e.target.files)}
            />
          </div>
        </div>
      </div>

      <div className={classes.formRow} data-test="business-address-field-group">
        <div className={classes.formGroup}>
          <Field
            name="businessMailingAddress"
            component={PlaceSearchFormField}
            props={{
              id: 'business-mailing-address-text-field',
              label: 'Business Mailing Address',
              fullWidth: true,
            }}
            initialValue={initialValues.businessMailingAddress}
            isEditing={businessProfileFormMode === VIEWABLE_FORM_MODES.EDITING}
            validate={[required]}
          />
        </div>
      </div>
      <div
        className={classes.formRow}
        data-test="business-material-field-group"
      >
        <div className={classes.formGroup}>
          <Field
            name="materialLocation"
            component={JsonPlaceSearchFormField}
            props={{
              id: 'material-location-text-field',
              label:
                'Where do you plan to purchase James Hardie products for your next project?',
              fullWidth: true,
            }}
            initialValue={initialValues.materialLocation}
            isEditing={businessProfileFormMode === VIEWABLE_FORM_MODES.EDITING}
            validate={
              businessProfileFormMode === VIEWABLE_FORM_MODES.EDITING
                ? [required]
                : []
            }
          />
        </div>
      </div>
      <div className={classes.formRow}>
        <div className={classNames(classes.formGroup, classes.halfFormGroup)}>
          {skillsetBuildOptions.length <= 0 && (
            <div className={classes.textCenter}>
              <CircularProgress size={20} />
            </div>
          )}
          {skillsetBuildOptions.length > 0 && (
            <Field
              name="businessSkillsetBuild"
              component={ButtonSelectFormField}
              props={{
                id: 'skillset-build-field',
                label: 'BUILD TYPE',
              }}
              options={skillsetBuildOptions}
              initialValue={initialValues.businessSkillsetBuild}
              isEditing={
                businessProfileFormMode === VIEWABLE_FORM_MODES.EDITING
              }
            />
          )}
        </div>
        <div className={classNames(classes.formGroup, classes.halfFormGroup)}>
          {skillsetLookOptions.length <= 0 && (
            <div className={classes.textCenter}>
              <CircularProgress size={20} />
            </div>
          )}
          {skillsetLookOptions.length > 0 && (
            <Field
              name="businessSkillsetLook"
              component={ButtonSelectFormField}
              props={{
                id: 'skillset-look-field',
                label: 'LOOKS',
              }}
              options={skillsetLookOptions}
              initialValue={initialValues.businessSkillsetLook}
              isEditing={
                businessProfileFormMode === VIEWABLE_FORM_MODES.EDITING
              }
            />
          )}
        </div>
      </div>
      <div className={classes.actionsRow}>{renderFormButton()}</div>
    </form>
  );
};

BuilderProfileBusinessForm.propTypes = propTypes;

const mapStateToProps = state => ({
  isUpdatingBusinessProfile: selectIsUpdatingBusinessProfile()(state),
  businessProfileFormMode: selectBusinessProfileFormMode()(state),
  skillsetBuildOptions: selectSkillsetBuildOptions()(state),
  skillsetLookOptions: selectSkillsetLookOptions()(state),
  builderProjectGallery: selectBuilderProjectGallery()(state),

  formValues: getFormValues(FORMS.BUILDER_PROFILE_BUSINESS)(state),
});

const mapDispatchToProps = dispatch => ({
  onEditUserProfile: profileType => dispatch(editUserProfile(profileType)),
  onEditUserProfileCancelled: profileType =>
    dispatch(editUserProfileCancelled(profileType)),
  onResetForm: form => dispatch(reset(form)),
  onUpdateBusinessAttributes: (
    accessToken,
    profileType,
    businessAttributes,
    previousBusinessAttributes,
  ) =>
    dispatch(
      updateBusinessAttributes(
        accessToken,
        profileType,
        businessAttributes,
        previousBusinessAttributes,
      ),
    ),
  onGetSkillsetOfType: type => dispatch(getSkillsetOfType(type)),
  setProjectGalleryImages: image =>
    dispatch(setBuilderProjectGalleryImages(image)),
  removeImageFromBuilderProjectGalleryImages: index =>
    dispatch(removeImageBuilderProjectGalleryImages(index)),
  resetProjectGalleryImages: () => dispatch(resetBuilderProjectGalleryImages()),
  changeFieldValue: (field, value) =>
    dispatch(change(FORMS.BUILDER_PROFILE_BUSINESS, field, value)),
  onAddNotification: (message, level, autoHideDuration) =>
    dispatch(apiCallFailed(message, level, autoHideDuration)),
});

export default reduxForm({
  form: FORMS.BUILDER_PROFILE_BUSINESS,
})(
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps,
    )(BuilderProfileBusinessForm),
  ),
);
